import usersPage from "./ui/ui";

export default usersPage;
